<template>
  <div class="d2-layout-header-aside-menu-side">
    <el-menu :collapse="asideCollapse" :unique-opened="true" :default-active="$route.name.toLowerCase()" ref="menu" @select="handleMenuSelectProxy" class="menu">
      <template v-for="(menu, menuIndex) in menuList">
        <d2-layout-header-aside-menu-item v-if="menu.children === undefined" :menu="menu" :key="menuIndex" />
        <d2-layout-header-aside-menu-sub v-else :menu="menu" :key="menuIndex" />
      </template>
    </el-menu>
    <div v-if="menuList.length === 0 && !asideCollapse" class="d2-layout-header-aside-menu-empty" flex="dir:top main:center cross:center">
      <d2-icon name="inbox" />
      <span>没有侧栏菜单</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import menuMixin from "../mixin/menu";
import d2LayoutMainMenuItem from "../components/menu-item/index.vue";
import d2LayoutMainMenuSub from "../components/menu-sub/index.vue";
import BScroll from "better-scroll";
export default {
  name: "d2-layout-header-aside-menu-side",
  mixins: [menuMixin],
  components: {
    "d2-layout-header-aside-menu-item": d2LayoutMainMenuItem,
    "d2-layout-header-aside-menu-sub": d2LayoutMainMenuSub,
  },
  data() {
    return {
      active: "",
      asideHeight: 300,
      BS: null,
    };
  },
  computed: {
    ...mapState("d2admin/menu", ["aside", "asideCollapse"]),
    ...mapState("d2admin/router", ["menuList"]),
  },
  watch: {
    // 折叠和展开菜单的时候销毁 better scroll
    asideCollapse(val) {
      this.scrollDestroy();
      setTimeout(() => {
        this.scrollInit();
      }, 500);
    },
    $route() {
      //滚动到焦点位置
      this.scrollToFocus();
    },
  },
  mounted() {
    this.scrollInit();
    this.scrollToFocus();
  },
  beforeDestroy() {
    this.scrollDestroy();
  },
  methods: {
    handleMenuSelectProxy(index, indexPath) {
      this.handleMenuSelect(index, indexPath)
      this.$nextTick(() => {
        this.$refs.menu.activeIndex = this.$route.name.toLowerCase();
      })
    },
    scrollInit() {
      this.BS = new BScroll(this.$el, {
        mouseWheel: true,
        click: true,
        // 如果你愿意可以打开显示滚动条
        // scrollbar: {
        //   fade: true,
        //   interactive: false
        // }
      });
      this.BS.on("scroll", () => {
        // 初始化完成
        // console.log("BetterScroll", this.BS.x, this.BS.y);
      });
    },
    scrollToFocus() {
      // 延迟是为了等待路由切换完毕
      setTimeout(() => {
        this.BS.scrollToElement(this.$refs.menu.$el.querySelector(`.is-active .title`), 300, 0, 0);
      }, 300);
    },
    scrollDestroy() {
      // https://github.com/d2-projects/d2-admin/issues/75
      try {
        this.BS.destroy();
      } catch (e) {
        delete this.BS;
        this.BS = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .menu:not(.el-menu--collapse) {
    .el-submenu__title {
      color: #fff !important;
    }
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/menu-side/index.vue"
}
</vue-filename-injector>
